import styled from 'styled-components';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

export const CloseButtonWrapper = styled('button')`
  display: flex;
  align-items: center;
`;

export const CloseButtonSVG = styled(CrossSolid)`
  fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  width: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x3spacePx}px;
`;
